import store from "../../../Store/Store";
import apiService from "../../../Services/APIService";
import { getCurrentUser } from "../../../Utils/Utilities";

// API for store Upgrade Attempt Date and count 
export const lastUpgradeAttempt = async () => {
  const state = store.getState();
  const currentUser = getCurrentUser();
  try {
    const upgdAtmptData = [{
      changeType: 'UPGDATMPT',
      agencyID: state.agencyData.data.AgencyID,
      userID: currentUser.UserID,
    }]
    const result = await apiService.accessSetData(11, 'set', upgdAtmptData);
    return result;
  } catch (error) {
    console.error(`Upgrade subscription request API error:`, error);
    throw error;
  }
};

export const createRazorpayOrderAPI = async (orderData) => {
  const state = store.getState();
  const currentUser = getCurrentUser();
  try {
    const payload = [{
      userID: currentUser.UserID,
      grandTotal: orderData.amount,
      currencyCode: orderData.currencyCode || 'INR',
      currencyID: orderData.currencyID || 24,
      countryID: orderData.countryID || 1,
      CurrencyCode: orderData.currencyCode || 'INR',
      CurrencyID: orderData.currencyID || 24,
      CountryID: orderData.countryID || 1,
    }]
    const result = await apiService.getData(12, 'getRZPayInfo', payload);
    return result;
  } catch (error) {
    console.error(`Create Razorpay order API error:`, error);
    throw error;
  }
};

export const upgradeSubscriptionAPI = async (upgradeData) => {
  try {
    const payload = [{
      ...upgradeData,
    }]
    const result = await apiService.sendChange(12, 'set', payload);
    return result;
  } catch (error) {
    console.error(`Upgrade subscription request API error:`, error);
    throw error;
  }
};

export const getCouponDetailsAPI = async (couponData) => {
  const state = store.getState();
  const currentUser = getCurrentUser();
  try {
    const payload = [{
      couponCode: couponData.couponCode,
      editionID: couponData.editionID,
      upgdType: couponData.upgdType, // 'SUB' or 'UPGD' or 'RNWL'
      upgdMode: couponData.upgdMode, // 'YY' or 'MM'
      upgdQty: couponData.upgdQty, // Quantity of periods (1, 2, 3, etc.)
      countryID: couponData.countryID || 1,
      accessType: couponData.accessType || 'BZPAY'
    }]
    const result = await apiService.getData(12, 'getCouponDetails', payload);
    return result;
  } catch (error) {
    console.error(`Get coupon details API error:`, error);
    throw error;
  }
};